import React from 'react';

import { UserSettings } from '../components';

const SettingsView: React.FC = () => {
	return <UserSettings finish={() => {}} />;
};

export default SettingsView;
